import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M16.6667 9.99967V5.33301C16.6667 4.22844 15.7713 3.33301 14.6667 3.33301H5.33337C4.2288 3.33301 3.33337 4.22844 3.33337 5.33301V14.6663C3.33337 15.7709 4.22881 16.6663 5.33338 16.6663H9.16671",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  fill: "none"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8.33337 3.33301V2.33301H7.33337V3.33301H8.33337ZM11.6667 3.33301H12.6667V2.33301H11.6667V3.33301ZM11.6667 6.66634V7.66634C12.219 7.66634 12.6667 7.21863 12.6667 6.66634H11.6667ZM8.33337 6.66634H7.33337C7.33337 7.21863 7.78109 7.66634 8.33337 7.66634V6.66634ZM8.33337 4.33301H11.6667V2.33301H8.33337V4.33301ZM10.6667 3.33301V6.66634H12.6667V3.33301H10.6667ZM11.6667 5.66634H8.33337V7.66634H11.6667V5.66634ZM9.33337 6.66634V3.33301H7.33337V6.66634H9.33337Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M13.9226 11.4226C14.2481 11.0972 14.2481 10.5695 13.9226 10.2441C13.5972 9.91864 13.0696 9.91864 12.7441 10.2441L11.0775 11.9107C10.9212 12.067 10.8334 12.279 10.8334 12.5C10.8334 12.721 10.9212 12.933 11.0775 13.0893L12.7441 14.7559C13.0696 15.0814 13.5972 15.0814 13.9226 14.7559C14.2481 14.4305 14.2481 13.9028 13.9226 13.5774L13.6786 13.3333H14.5834C15.2737 13.3333 15.8334 13.893 15.8334 14.5833C15.8334 15.2737 15.2737 15.8333 14.5834 15.8333H11.6667C11.2065 15.8333 10.8334 16.2064 10.8334 16.6667C10.8334 17.1269 11.2065 17.5 11.6667 17.5H14.5834C16.1942 17.5 17.5 16.1942 17.5 14.5833C17.5 12.9725 16.1942 11.6667 14.5834 11.6667H13.6786L13.9226 11.4226Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}